import { Menu } from '../models';
import { featuresConstants } from './features.constants';

export const UserMenu: Menu[] = [
  {
    label: 'Dashboard',
    icon: 'fa-solid fa-gauge', // or 'fa-solid fa-chart-line'
    routeLink: '/dashboard',
    key: featuresConstants.dashboard.type,
    visible: true,
  },
  {
    label: 'Claims',
    icon: 'fa-solid fa-file-invoice-dollar',
    routeLink: '/claims',
    key: featuresConstants.claims.type,
    visible: true,
  },
  {
    label: 'CSV Field Mapper',
    icon: 'fa-solid fa-file-csv',
    routeLink: '/csv-field-mapper',
    key: featuresConstants.csvFieldMapper.type,
    visible: true,
  },
  {
    label: 'Call Dialer',
    icon: 'fa-solid fa-phone',
    routeLink: '/call-dialer',
    key: featuresConstants.callDialer.type,
    visible: true,
  },
  {
    label: 'Activity Logs',
    icon: 'fa-solid fa-clock-rotate-left',
    routeLink: '/activity-logs',
    key: featuresConstants.activityLogs.type,
    visible: true,
  },
  {
    label: 'Batch Management',
    icon: 'fa-solid fa-layer-group',
    routeLink: '/batch-management',
    key: featuresConstants.batches.type,
    visible: true,
  },
  {
    label: 'Client Management',
    icon: 'fa-solid fa-users',
    routeLink: '/client-management',
    key: featuresConstants.clientManagement.type,
    visible: true,
  },
  {
    label: 'Batch Report',
    icon: 'fa-solid fa-chart-bar',
    routeLink: '/batch-report',
    key: featuresConstants.batchReports.type,
    visible: true,
  },
  {
    icon: 'fa-solid fa-user-shield',
    label: 'Roles Management',
    routeLink: '/management/roles',
    key: featuresConstants.roleManagement.type,
    visible: true,
  },
  {
    icon: 'fa-solid fa-sliders',
    label: 'Features Management',
    routeLink: '/management/features',
    key: featuresConstants.featuresManagement.type,
    visible: true,
  },
];

export const SystemAdminMenu: Menu[] = [
  {
    label: 'Client Management',
    icon: 'fa-solid fa-users',
    routeLink: '/client-management',
    key: featuresConstants.clientManagement.type,
    visible: true,
  },
  {
    icon: 'fa-solid fa-user-shield',
    label: 'Roles Management',
    routeLink: '/management/roles',
    key: featuresConstants.roleManagement.type,
    visible: true,
  },
  {
    icon: 'fa-solid fa-sliders',
    label: 'Features Management',
    routeLink: '/management/features',
    key: featuresConstants.featuresManagement.type,
    visible: true,
  },
];
